export default {"src":"/_next/static/media/success.aa4e3b72.svg","height":208,"width":280,"blurWidth":0,"blurHeight":0};